"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetaData = void 0;
exports.toMetadataTransport = toMetadataTransport;
const typebox_1 = require("@sinclair/typebox");
/**
 * toMetadataTransport transforms an entity object into a transportable metadata format.
 *
 * @param {Object} entity - An entity object which must contain 'createdAt', 'createdByUserID', 'lastUpdatedAt', 'lastUpdatedByUserID' properties.
 *
 * @returns {MetaData} - The resulting metadata object which includes 'createdAt', 'createdByUserID', 'lastUpdatedAt', 'lastUpdatedByUserID' properties in string format.
 * 'createdAt' and 'lastUpdatedAt' are converted into ISO string format and 'createdByUserID' and 'lastUpdatedByUserID' are assumed to be in 'uuid' format.
 */
function toMetadataTransport(entity) {
    return {
        createdAt: entity.createdAt.toISOString(),
        createdByUserID: entity.createdByUserID,
        lastUpdatedAt: entity.lastUpdatedAt.toISOString(),
        lastUpdatedByUserID: entity.lastUpdatedByUserID,
    };
}
exports.MetaData = typebox_1.Type.Object({
    createdAt: typebox_1.Type.String({ format: 'date-time' }),
    createdByUserID: typebox_1.Type.String({ format: 'uuid' }),
    lastUpdatedAt: typebox_1.Type.String({ format: 'date-time' }),
    lastUpdatedByUserID: typebox_1.Type.String({ format: 'uuid' }),
});
//# sourceMappingURL=meta-data.js.map